module.exports = __webpack_public_path__ + "media/images/icons/box-icon-9d5ae62b06bc9dbe58cf97c4e8902c9f.svg";